import { IMustHaveClickEvent } from './interfaces/IMustHaveClickEvent';
import { IMayHaveBoundry } from './interfaces/IMayHaveBoundry';
import { GMarkerLabel } from '../gmap/gmarket.label.model';
import { GCoordinate } from '../gmap/gcoordinate.model';
import { GUrl } from '../gmap/gurl.model';

export class GMarker{
        
    id: number;
    title: string;
    position: GCoordinate;
    url?: GUrl[];
    icon: any;
    label : GMarkerLabel;
    description: string;

	animation?: google.maps.Animation;
    infoWindowContent?: { key: string, value: string }[];
    color?: "Red" | "Blue" | "Green" | "Yellow" | "Purple" | "Orange" | "LightBlue" | "Pink"; // Buradaki enumlar google'ın yayınladığı farklı pin renklerini kullanmak amacıyla marker'ı renklendirir.
    hasClickEvent: boolean;
    //Number marker kullanılmak isteniyorsa aşağıdaki propertyler set edilmelidir.
    isNumberMarker: boolean;
    numberMarkerColor?: 'Gray' | 'DarkGray' | 'Green' | 'LightGreen' | 'DarkGreen' | 'Yellow' | 'DarkYellow' | 'Red' | 'BrightRed'
    | 'Orange' | 'Cyan' | 'Blue' | 'DarkBlue' | 'Purple' | 'DarkPurple' | 'Pink' | 'LightPink' | 'Magenta'; 
    numberMarkerNumber?: number;
}
